import { eventBus } from './EventBus';

export const SOLAR_BATTERY_POWER_EVENT = 'solar:battery-power';
export const SOLAR_PV_TOTAL_POWER_EVENT = 'solar:pv-total-power';

let lastBatteryPowerW: number | null = null;
let lastPvTotalPowerW: number | null = null;

export function getLastSolarBatteryPowerW(): number | null {
  return lastBatteryPowerW;
}

export function getLastSolarPvTotalPowerW(): number | null {
  return lastPvTotalPowerW;
}

/** Potencia batería agregada (W), misma convención que el diagrama de flujo. */
export function publishSolarBatteryPowerW(watts: number | null | undefined): void {
  if (watts === null || watts === undefined || typeof watts !== 'number' || Number.isNaN(watts)) {
    return;
  }
  if (lastBatteryPowerW === watts) {
    return;
  }
  lastBatteryPowerW = watts;
  eventBus.emit(SOLAR_BATTERY_POWER_EVENT, watts);
}

/** Potencia total PV agregada (W), suma de inversores activos como vista "planta" en el tab Flujo. */
export function publishSolarPvTotalPowerW(watts: number | null | undefined): void {
  if (watts === null || watts === undefined || typeof watts !== 'number' || Number.isNaN(watts)) {
    return;
  }
  if (lastPvTotalPowerW === watts) {
    return;
  }
  lastPvTotalPowerW = watts;
  eventBus.emit(SOLAR_PV_TOTAL_POWER_EVENT, watts);
}
